import { apiRequest } from '../../../services/api'
import { Option, OptionsLoaderData, OptionsSubpage, OptionsView } from '../types'

export const EMPTY_RESPONSE: OptionsLoaderData = {
  ticker: null,
  view: OptionsView.ChainByDate,
  subpage: OptionsSubpage.Prices,
  options: [],
  lastClose: null,
  lastTime: null,
  expiries: [],
  currentExpiry: '',
}

interface OptionsDataQuery {
  expiry?: string | null
  strike?: number | null
  filterLastClose?: boolean | null
}

interface OptionsData {
  optionable: boolean
  options: Option[]
  lastClose: number | null
  lastTime: number | null
}

export function optionsData(ticker: string, query?: OptionsDataQuery) {
  return apiRequest<OptionsData>(`/api/options/${ticker}`, { query })
}

export function expiriesData(ticker: string) {
  return apiRequest<string[]>(`/api/options/${ticker}/expiries`)
}

export function strikesData(ticker: string) {
  return apiRequest<number[]>(`/api/options/${ticker}/strikes`)
}
